<template>
  <!--专用号依据-->
  <h-list-page>
    <!-- 搜索条件 -->
    <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <!-- 专用号 -->
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <!-- 请输入至少四位专用号 -->
          <h-autocomplete
              popper-class="planHidden"
              v-model="searchData.mtlNo"
              :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false"
              @input="() =>searchData.mtlNo.length < 4? (plan.showMtlPlan = false): ''"
              @clear="plan.showMtlPlan = false"
              clearable
              :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')"
              @blur="myBlur('showMtlPlan')"
              @focus="myFocus3('showMtlPlan')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="loading.mtlLoading" ref="filterTable" :data="mtlNoList" border size="small" max-height="252" @row-click="clickMtlNo" @mousedown="planBlur=true">
              <!-- 物料号 -->
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <!-- 物料名称 -->
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>
        <template #operate>
          <h-button type="primary" :loading="tableListLoading" @click="paginationQuery(1)">
            <template #icon>
              <search/>
            <!-- 查询 -->
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <div style="position: relative;margin-top: 10px;">
      <!-- 新品检验计划 -->
      <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')" :is-left="0" :h-data="tableDataList">
        <!-- <template #buttonGroup>
          <h-button-group>
            <h-button type="default" @click="derive()">
              导出
              <template #icon>
                <export/>
              </template>
            </h-button>
          </h-button-group>
        </template> -->

        <!-- 请点击“查询”数据 -->
        <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="tableListLoading" height="540"
                  @selection-change="listCheckBoxChange" border :data="tableDataList" size="small"
                  style="width: 100%;min-height: 540px;">
          <!-- 专用号 -->
          <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="150">
            <template #default="{row}">
              <div class="h-global-font--blue" @click="lookDetail(row.mtlNo)">{{ row.mtlNo }}</div>
            </template>
          </el-table-column>
          <!-- 物料名称 -->
          <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="170"></el-table-column>
          <!-- 状态 -->
          <el-table-column prop="statusName" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" min-width="60"></el-table-column>
          <!-- <el-table-column prop="isrtEmpName" label="录入人" min-width="100"></el-table-column> -->
          <!-- 录入时间 -->
          <el-table-column prop="isrtDate" :label="h_i18n('0039880117c13787732d259f5bc9f7f5')" min-width="170" :formatter="({isrtDate})=>formDate(isrtDate,6)"></el-table-column>
          <!-- <el-table-column prop="updateEmpName" label="修改人" min-width="100"></el-table-column> -->
          <!-- 修改时间 -->
          <el-table-column prop="updateDate" :label="h_i18n('1303e638b5ff6d3c4d78b76be2d19756')" min-width="170" :formatter="({updateDate})=>formDate(updateDate,6)"></el-table-column>
          <!-- <el-table-column prop="auditEmpName" label="审核人" min-width="170"></el-table-column> -->
          <!-- 审核时间 -->
          <el-table-column prop="auditDate" :label="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" min-width="170" :formatter="({auditDate})=>formDate(auditDate,6)"></el-table-column>
        </el-table>
        <template #pagination>
          <el-pagination background @current-change="paginationQuery" v-model:current="pageNation.pageIndex"
                         :page-size="10" layout="total, prev, pager, next,jumper" :total="pageNation.total">
          </el-pagination>
        </template>
      </h-table-card>
    </div>
  </h-list-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import axios from "axios";

export default {
  name: "EnterpriseStandardDetail",
  data() {
    return {
      searchData: {
        mtlNo: "",
        supplyCode: ""
      },
      plan: {},
      tableDataList: [],
      tableListLoading: false,
      sybList: [],
      pageNation: {
        pageIndex: 1,
        total: 0
      },
      http: {
        searchHttp: null,//查询列表--避免重复请求数据覆盖的问题
        departureListHttp: null,//发车单状态
        mtlSearchHttp: null,//专用号模糊查询
        supplySearchHttp: null,//供应商模糊查询
        reasonForConversionHttp: null,//转换原因
      },
      loading: {
        mtlLoading: false,//专用号查询
        supplyLoading: false,//供应商查询
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    h_i18n,
    lookDetail(mtlNo) {
      this.$router.push({
        name: "EnterpriseStandardDetail",
        query: {
          mtlNo: mtlNo
        }
      })
    },
    formDate(val, len = 3) {
      if (val) {
        return this.time(val, len)
      } else {
        return "-"
      }
    },
    init() {
      this.searchData.supplyCode = this.$route.query.supplyCode ? this.$route.query.supplyCode : ""
      this.searchData.mtlNo = this.$route.query.mtlNo ? this.$route.query.mtlNo : ""
      this.searchTableList()
    },
    changeMethod() {
      this.postThisPageHeight()
    },
    listCheckBoxChange(val) {
      this.multipleSelection = val;
    },
    derive() {
      if (this.pageNation.total > 5000) {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 导出数量大于5000条
          message: h_i18n('748c802d8fe36ada78520df791295747'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        })
      } else {
        this.loading.exportLoading = true
        this.$http({
          method: "post",
          url: "/base/patternPlan/exportList",
          data: {
            supplyCode: this.searchData.supplyCode,
            mtlNo: this.searchData.mtlNo
          },
          responseType: "blob",
        }).then(async (res) => {
          if (res.status === 200) {
            try {
              let blobText = new Blob([res.data], {
                type: "application/json",
              }); // 文件流
              let response = JSON.parse(await blobText.text())
              if (response.success === false) {
                this.loading.exportLoading = false
                this.error(response.msg)
              }
            } catch (e) {
              let blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              }); // 文件流
              let blobUrl = URL.createObjectURL(blob);
              const link = document.createElement("a"); //模拟a链接，不支持低版本ie
              // 专用号依据.xlsx
              link.download = h_i18n('20ece3e4d1d0b00af4c7c6e2f81acf1b');
              link.style.display = "none";
              link.href = blobUrl;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
              this.loading.exportLoading = false
            }
          }
        }).catch((err) => {
          this.loading.exportLoading = false
        });
      }
    },
    paginationQuery(val) {
      this.pageNation.pageIndex = val;
      if (this.http.searchHttp) {
        this.http.searchHttp.cancel()
        this.http.searchHttp = null
        this.loading.tableListLoading = false;
      }
      this.searchTableList();
    },
    searchTableList() {
      this.http.searchHttp = axios.CancelToken.source();
      setTimeout(() => this.loading.tableListLoading = true)
      this.tableDataList = [];
      this.tableListLoading = true
      return this.$http({
        method: "get",
        url: "/base/patternPlan/searchStandards",
        params: {
          supplyCode: this.searchData.supplyCode,
          mtlNo: this.searchData.mtlNo
        },
        cancelToken: this.http.searchHttp.token,
      }).then((res) => {
        this.tableListLoading = false;
        if (res.data.code === "200") {
          if (res.data.data) {
            this.tableDataList = res.data.data
            this.pageNation.total = res.data.data.length;
          } else {
            this.tableDataList = [];
            this.pageNation.total = 0;
          }
        }
      }).catch((err) => {
        this.tableListLoading = false;
        if (err.toString() !== "Cancel") {
          // 查询失败
          this.error(h_i18n('0d66ed02d74d0bd89431d6d59533ffb3') + err)
        }
      });
    },
    /**
     * 处理两个查询
     * *******************************************************************************
     */
    myBlur(v) {
      if (!this.planBlur) {
        this.plan[v] = false;
      }
    },
    myFocus3(v) {
      this.planBlur = false
      if (this.searchData.mtlNo.length >= 4) {
        this.plan[v] = true;
      }
    },
    // 供应商获取焦点
    myFocus4(v) {
      this.planBlur = false;
      if (this.searchData.supplyCode.length >= 2) {
        this.plan[v] = true;
      }
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.http.mtlSearchHttp) this.http.mtlSearchHttp.cancel()
      this.http.mtlSearchHttp = axios.CancelToken.source()
      if (this.searchData.mtlNo.length < 4) {
        this.plan.showMtlPlan = false;
      } else {
        this.loading.mtlLoading = true;
        this.plan.showMtlPlan = true;
        this.$http({
          method: "POST",
          url: "/base/basicData/searchMaterielList",
          headers: {"content-type": "application/json"},
          data: {
            mtlNo: this.searchData.mtlNo,
          },
          cancelToken: this.http.mtlSearchHttp.token
        }).then((res) => {
          this.mtlNoList = res.data.data;
          this.loading.mtlLoading = false;
        }).catch(e => {
        });
      }
    },
    clickMtlNo(row) {
      this.searchData.mtlNo = row.mtlNo;
      this.plan.showMtlPlan = false;
    },
    clearMtlNo() {
      this.plan.showMtlPlan = false;
    },
    supplyCodeChange() {
      this.planBlur = false;
      if (this.http.supplySearchHttp) this.http.supplySearchHttp.cancel()
      this.http.supplySearchHttp = axios.CancelToken.source()
      if (this.searchData.supplyCode.length < 2) {
        this.plan.showSupplyPlan = false;
      } else {
        this.loading.supplyLoading = true;
        this.plan.showSupplyPlan = true;
        this.$http({
          method: "post",
          url: "/base/basicData/searchSupplierList",
          headers: {"content-type": "application/json"},
          data: {
            supplyCode: this.searchData.supplyCode,
          },
          cancelToken: this.http.supplySearchHttp.token
        }).then((res) => {
          this.supplyCodeList = res.data.data;
          this.loading.supplyLoading = false;
        }).catch(e => {
        });
      }
    },
    clickSupplierCode(row) {
      this.planBlur = true;
      this.searchData.supplyCode = row.supplyCode;
      this.plan.showSupplyPlan = false;
    },
  }
}
</script>

<style lang="scss">
.planHidden {
  display: none;
}
</style>